import { lazySelectPreviousNodeInternal } from 'owa-mail-folder-forest-actions';
import { selectPreviousNode } from 'owa-mail-search';
import { orchestrator } from 'satcheljs';

/**
 * This orchestrator dispatches an internal action to handle the action so we
 * can lazy load the orchestrator.
 */
export default orchestrator(selectPreviousNode, async actionMessage => {
    const selectPreviousNodeInternal = await lazySelectPreviousNodeInternal.import();
    selectPreviousNodeInternal(actionMessage.actionSource);
});
